//eslint-disable-next-line
import { $asyncGet, $asyncPost } from "../common";

/**
 * 获取省份列表
 * @returns {Promise} 返回省份列表数据
 */
export const getProvinceList = function () {
  return $asyncGet(`v3/common/GetProvinceList`);
}

/**
 * 获取城市列表
 * @param {string} province_code 省份编码
 * @returns {Promise} 返回城市列表数据
 */
export const getCityList = function (province_code) {
  return $asyncGet(`v3/common/GetCityList?province_code=${province_code}`);
}

/**
 * 获取区/县列表
 * @param {string} province_code 省份编码
 * @param {string} city_code 城市编码
 * @returns {Promise} 返回区/县列表数据
 */
export const getRegionList = function (province_code, city_code) {
  return $asyncGet(`v3/common/GetRegionList?province_code=${province_code}&city_code=${city_code}`);
}